/* tslint:disable */
/* eslint-disable */
/**
 * hr-report backend
 * hr-report backend
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kanya384@mail.ru
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface AuthSignInRequest
 */
export interface AuthSignInRequest {
    /**
     *
     * @type {string}
     * @memberof AuthSignInRequest
     */
    'login'?: string;
    /**
     *
     * @type {string}
     * @memberof AuthSignInRequest
     */
    'pass'?: string;
}
/**
 * 
 * @export
 * @interface AuthSignInResponse
 */
export interface AuthSignInResponse {
    /**
     * 
     * @type {string}
     * @memberof AuthSignInResponse
     */
    'refreshToken'?: string;
    /**
     * 
     * @type {string}
     * @memberof AuthSignInResponse
     */
    'token'?: string;
}
/**
 * 
 * @export
 * @interface CallCallListResponse
 */
export interface CallCallListResponse {
    /**
     * 
     * @type {number}
     * @memberof CallCallListResponse
     */
    'count'?: number;
    /**
     * 
     * @type {Array<CallCallResponse>}
     * @memberof CallCallListResponse
     */
    'list'?: Array<CallCallResponse>;
}
/**
 * 
 * @export
 * @interface CallCallResponse
 */
export interface CallCallResponse {
    /**
     * 
     * @type {string}
     * @memberof CallCallResponse
     */
    'call_date'?: string;
    /**
     * 
     * @type {number}
     * @memberof CallCallResponse
     */
    'call_length'?: number;
    /**
     * 
     * @type {string}
     * @memberof CallCallResponse
     */
    'call_link'?: string;
    /**
     * 
     * @type {DomainCallType}
     * @memberof CallCallResponse
     */
    'call_type'?: DomainCallType;
    /**
     * 
     * @type {string}
     * @memberof CallCallResponse
     */
    'comment'?: string;
    /**
     * 
     * @type {string}
     * @memberof CallCallResponse
     */
    'communication_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CallCallResponse
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CallCallResponse
     */
    'entity_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CallCallResponse
     */
    'id'?: string;
    /**
     * 
     * @type {number}
     * @memberof CallCallResponse
     */
    'lead_stage'?: number;
    /**
     * 
     * @type {number}
     * @memberof CallCallResponse
     */
    'status_id'?: number;
    'trigger_types'?: Array<string>;
    'trigger_phrases'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CallCallResponse
     */
    'modified_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CallCallResponse
     */
    'operator_name'?: string;
    /**
     * 
     * @type {number}
     * @memberof CallCallResponse
     */
    'pipeline_id'?: number;
    /**
     * 
     * @type {string}
     * @memberof CallCallResponse
     */
    'region'?: string;
    /**
     * 
     * @type {string}
     * @memberof CallCallResponse
     */
    'task_name'?: string;
}
/**
 * 
 * @export
 * @interface CallCallStatsOfOperator
 */
export interface CallCallStatsOfOperator {
    /**
     * Время в звонке в секундах
     * @type {number}
     * @memberof CallCallStatsOfOperator
     */
    'inCallInSeconds'?: number;
    /**
     * Время в post в секундах
     * @type {number}
     * @memberof CallCallStatsOfOperator
     */
    'inPostInSeconds'?: number;
    /**
     * Время завершения последнего звонка
     * @type {string}
     * @memberof CallCallStatsOfOperator
     */
    'lastProcessedCallEndTime'?: string;
    /**
     * Логин оператора
     * @type {string}
     * @memberof CallCallStatsOfOperator
     */
    'operatorLogin'?: string;
    /**
     * 
     * @type {string}
     * @memberof CallCallStatsOfOperator
     */
    'taskName'?: string;
    /**
     * Время в режиме ожидания звонка (дата конца предыдущего звонка - дата начала следующего звонка)
     * @type {number}
     * @memberof CallCallStatsOfOperator
     */
    'waitForCallSeconds'?: number;
}
/**
 * 
 * @export
 * @interface CallCallsReportResponse
 */
export interface CallCallsReportResponse {
    /**
     * 
     * @type {string}
     * @memberof CallCallsReportResponse
     */
    'link'?: string;
}
/**
 * 
 * @export
 * @interface CallDirectionOccupancyStat
 */
export interface CallDirectionOccupancyStat {
    /**
     * 
     * @type {number}
     * @memberof CallDirectionOccupancyStat
     */
    'call_average'?: number;
    /**
     * 
     * @type {Array<CallCallStatsOfOperator>}
     * @memberof CallDirectionOccupancyStat
     */
    'debug_list'?: Array<CallCallStatsOfOperator>;
    /**
     * 
     * @type {string}
     * @memberof CallDirectionOccupancyStat
     */
    'name'?: string;
    /**
     * 
     * @type {number}
     * @memberof CallDirectionOccupancyStat
     */
    'occupancy'?: number;
    /**
     * 
     * @type {number}
     * @memberof CallDirectionOccupancyStat
     */
    'operators_count'?: number;
}
/**
 * 
 * @export
 * @interface CallGetLocalLinkForAudioResponse
 */
export interface CallGetLocalLinkForAudioResponse {
    /**
     * 
     * @type {string}
     * @memberof CallGetLocalLinkForAudioResponse
     */
    'link'?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const DomainCallType = {
    Incoming: 'incoming',
    Outgoing: 'outgoing',
    NotDefined: 'not_defined'
} as const;

export type DomainCallType = typeof DomainCallType[keyof typeof DomainCallType];


/**
 * 
 * @export
 * @interface LeadgenStatus
 */
export interface LeadgenStatus {
    /**
     * 
     * @type {number}
     * @memberof LeadgenStatus
     */
    'pipelineId': number;
    /**
     * 
     * @type {string}
     * @memberof LeadgenStatus
     */
    'pipelineName': string;
    /**
     * 
     * @type {number}
     * @memberof LeadgenStatus
     */
    'statusId': number;
    /**
     * 
     * @type {string}
     * @memberof LeadgenStatus
     */
    'statusName': string;
}
/**
 * 
 * @export
 * @interface OperatorCalculationSettingsResponse
 */
export interface OperatorCalculationSettingsResponse {
    /**
     * 
     * @type {number}
     * @memberof OperatorCalculationSettingsResponse
     */
    'denominator'?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof OperatorCalculationSettingsResponse
     */
    'excluded_statuses'?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof OperatorCalculationSettingsResponse
     */
    'numerator'?: number;
}
/**
 * 
 * @export
 * @interface OperatorCount
 */
export interface OperatorCount {
    /**
     * 
     * @type {Array<OperatorSpeedProcessing>}
     * @memberof OperatorCount
     */
    'speed_processing'?: Array<OperatorSpeedProcessing>;
    /**
     * 
     * @type {number}
     * @memberof OperatorCount
     */
    'total_count'?: number;
}
/**
 * 
 * @export
 * @interface OperatorProjectCount
 */
export interface OperatorProjectCount {
    /**
     * 
     * @type {Array<OperatorProjectSpeedProcessing>}
     * @memberof OperatorProjectCount
     */
    'speed_processing'?: Array<OperatorProjectSpeedProcessing>;
    /**
     * 
     * @type {number}
     * @memberof OperatorProjectCount
     */
    'total_count'?: number;
}
/**
 * 
 * @export
 * @interface OperatorProjectSpeedProcessing
 */
export interface OperatorProjectSpeedProcessing {
    /**
     * 
     * @type {number}
     * @memberof OperatorProjectSpeedProcessing
     */
    'average_per_operator'?: number;
    /**
     * 
     * @type {string}
     * @memberof OperatorProjectSpeedProcessing
     */
    'project'?: string;
    /**
     * 
     * @type {number}
     * @memberof OperatorProjectSpeedProcessing
     */
    'total_records'?: number;
    /**
     * 
     * @type {number}
     * @memberof OperatorProjectSpeedProcessing
     */
    'unique_operators'?: number;
}
/**
 * 
 * @export
 * @interface OperatorSpeedProcessing
 */
export interface OperatorSpeedProcessing {
    /**
     * 
     * @type {number}
     * @memberof OperatorSpeedProcessing
     */
    'average_per_operator'?: number;
    /**
     * 
     * @type {string}
     * @memberof OperatorSpeedProcessing
     */
    'project'?: string;
    /**
     * 
     * @type {string}
     * @memberof OperatorSpeedProcessing
     */
    'task_name'?: string;
    /**
     * 
     * @type {number}
     * @memberof OperatorSpeedProcessing
     */
    'total_records'?: number;
    /**
     * 
     * @type {number}
     * @memberof OperatorSpeedProcessing
     */
    'unique_operators'?: number;
}
/**
 * 
 * @export
 * @interface OperatorUpdateCalculationSettingsRequest
 */
export interface OperatorUpdateCalculationSettingsRequest {
    /**
     * 
     * @type {number}
     * @memberof OperatorUpdateCalculationSettingsRequest
     */
    'denominator': number;
    /**
     * 
     * @type {Array<string>}
     * @memberof OperatorUpdateCalculationSettingsRequest
     */
    'excluded_statuses': Array<string>;
    /**
     * 
     * @type {number}
     * @memberof OperatorUpdateCalculationSettingsRequest
     */
    'numerator': number;
}
/**
 * 
 * @export
 * @interface RepositoryOperatorCallStat
 */
export interface RepositoryOperatorCallStat {
    /**
     * 
     * @type {number}
     * @memberof RepositoryOperatorCallStat
     */
    'in_call'?: number;
    /**
     * 
     * @type {string}
     * @memberof RepositoryOperatorCallStat
     */
    'login'?: string;
    /**
     * 
     * @type {number}
     * @memberof RepositoryOperatorCallStat
     */
    'post_work_time'?: number;
}
/**
 * 
 * @export
 * @interface RestErrorResponse
 */
export interface RestErrorResponse {
    /**
     * 
     * @type {string}
     * @memberof RestErrorResponse
     */
    'message'?: string;
}
/**
 * 
 * @export
 * @interface RestStatsReportResponse
 */
export interface RestStatsReportResponse {
    /**
     * 
     * @type {string}
     * @memberof RestStatsReportResponse
     */
    'file'?: string;
}
/**
 * 
 * @export
 * @interface UserChangePasswordRequest
 */
export interface UserChangePasswordRequest {
    /**
     * 
     * @type {string}
     * @memberof UserChangePasswordRequest
     */
    'password'?: string;
}
/**
 * 
 * @export
 * @interface UserCreateUserRequest
 */
export interface UserCreateUserRequest {
    /**
     * 
     * @type {string}
     * @memberof UserCreateUserRequest
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserCreateUserRequest
     */
    'login'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserCreateUserRequest
     */
    'modified_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserCreateUserRequest
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserCreateUserRequest
     */
    'pass'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserCreateUserRequest
     */
    'role'?: string;
}
/**
 * 
 * @export
 * @interface UserUpdateUserRequest
 */
export interface UserUpdateUserRequest {
    /**
     * 
     * @type {string}
     * @memberof UserUpdateUserRequest
     */
    'login'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserUpdateUserRequest
     */
    'name'?: string;
}
/**
 * 
 * @export
 * @interface UserUserResponse
 */
export interface UserUserResponse {
    /**
     * 
     * @type {string}
     * @memberof UserUserResponse
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserUserResponse
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserUserResponse
     */
    'login'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserUserResponse
     */
    'modified_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserUserResponse
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserUserResponse
     */
    'pass'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserUserResponse
     */
    'role'?: string;
}

/**
 * AuthApi - axios parameter creator
 * @export
 */
export const AuthApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * авторизация пользователя.
         * @summary авторизация пользователя.
         * @param {AuthSignInRequest} user Данные для аутентификации
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthSignInPost: async (user: AuthSignInRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'user' is not null or undefined
            assertParamExists('apiAuthSignInPost', 'user', user)
            const localVarPath = `/api/auth/sign-in`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(user, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuthApi - functional programming interface
 * @export
 */
export const AuthApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AuthApiAxiosParamCreator(configuration)
    return {
        /**
         * авторизация пользователя.
         * @summary авторизация пользователя.
         * @param {AuthSignInRequest} user Данные для аутентификации
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuthSignInPost(user: AuthSignInRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthSignInResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuthSignInPost(user, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AuthApi - factory interface
 * @export
 */
export const AuthApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AuthApiFp(configuration)
    return {
        /**
         * авторизация пользователя.
         * @summary авторизация пользователя.
         * @param {AuthSignInRequest} user Данные для аутентификации
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthSignInPost(user: AuthSignInRequest, options?: any): AxiosPromise<AuthSignInResponse> {
            return localVarFp.apiAuthSignInPost(user, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AuthApi - object-oriented interface
 * @export
 * @class AuthApi
 * @extends {BaseAPI}
 */
export class AuthApi extends BaseAPI {
    /**
     * авторизация пользователя.
     * @summary авторизация пользователя.
     * @param {AuthSignInRequest} user Данные для аутентификации
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public apiAuthSignInPost(user: AuthSignInRequest, options?: AxiosRequestConfig) {
        return AuthApiFp(this.configuration).apiAuthSignInPost(user, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * CallApi - axios parameter creator
 * @export
 */
export const CallApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * получить отфильтрованный список звонков.
         * @summary получить отфильтрованный список звонков.
         * @param {number} offset Начальный индекс
         * @param {number} limit Лимит
         * @param {string} [from] дата передачи лида от
         * @param {string} [to] дата передачи лида до
         * @param {string} [entityId] id лида
         * @param {Array<string>} [taskName] название задачи
         * @param {string} [callType] тип звонка
         * @param {Array<string>} [operatorName] имя оператора
         * @param {string} [pipelineId] id воронки
         * @param {string} [leadStage] id статуса амо
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCallGet: async (offset: number, limit: number, from?: string, to?: string, entityId?: string, taskName?: Array<string>, callType?: string, operatorName?: Array<string>, pipelineId?: string, leadStage?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'offset' is not null or undefined
            assertParamExists('apiCallGet', 'offset', offset)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('apiCallGet', 'limit', limit)
            const localVarPath = `/api/call`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (from !== undefined) {
                localVarQueryParameter['from'] = from;
            }

            if (to !== undefined) {
                localVarQueryParameter['to'] = to;
            }

            if (entityId !== undefined) {
                localVarQueryParameter['entity_id'] = entityId;
            }

            if (taskName) {
                localVarQueryParameter['task_name[]'] = taskName.join(COLLECTION_FORMATS.csv);
            }

            if (callType !== undefined) {
                localVarQueryParameter['call_type'] = callType;
            }

            if (operatorName) {
                localVarQueryParameter['operator_name[]'] = operatorName.join(COLLECTION_FORMATS.csv);
            }

            if (pipelineId !== undefined) {
                localVarQueryParameter['pipeline_id'] = pipelineId;
            }

            if (leadStage !== undefined) {
                localVarQueryParameter['lead_stage'] = leadStage;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * скачать звонок (иначе не работает seek в аудио).
         * @summary скачать звонок (иначе не работает seek в аудио).
         * @param {string} url Идентификатор пользователя
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCallLinkGet: async (url: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'url' is not null or undefined
            assertParamExists('apiCallLinkGet', 'url', url)
            const localVarPath = `/api/call/link`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (url !== undefined) {
                localVarQueryParameter['url'] = url;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * получить список операторов.
         * @summary получить список операторов.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCallOperatorsGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/call/operators`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * получить отфильтрованный список звонков.
         * @summary получить отфильтрованный список звонков.
         * @param {string} date Дата в формате 02.01.2006
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCallStatsDateGet: async (date: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'date' is not null or undefined
            assertParamExists('apiCallStatsDateGet', 'date', date)
            const localVarPath = `/api/call/stats/{date}`
                .replace(`{${"date"}}`, encodeURIComponent(String(date)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * скачать звонок (иначе не работает seek в аудио).
         * @summary скачать звонок (иначе не работает seek в аудио).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCallStatusesGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/call/statuses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * получить список задач.
         * @summary получить список задач.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCallTasksGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/call/tasks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * получить occupancy и кол-во операторов по направлению.
         * @summary получить occupancy и кол-во операторов по направлению.
         * @param {string} [from] дата передачи лида от
         * @param {string} [to] дата передачи лида до
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCallTasksStatsGet: async (from?: string, to?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/call/tasks_stats`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (from !== undefined) {
                localVarQueryParameter['from'] = from;
            }

            if (to !== undefined) {
                localVarQueryParameter['to'] = to;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * получить отфильтрованный список звонков.
         * @summary получить отфильтрованный список звонков.
         * @param {string} [from] дата передачи лида от
         * @param {string} [to] дата передачи лида до
         * @param {string} [entityId] id лида
         * @param {Array<string>} [taskName] название задачи
         * @param {string} [callType] тип звонка
         * @param {Array<string>} [operatorName] имя оператора
         * @param {string} [pipelineId] id воронки
         * @param {string} [leadStage] id статуса амо
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCallXlsxGet: async (from?: string, to?: string, entityId?: string, taskName?: Array<string>, callType?: string, operatorName?: Array<string>, pipelineId?: string, leadStage?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/call/xlsx`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (from !== undefined) {
                localVarQueryParameter['from'] = from;
            }

            if (to !== undefined) {
                localVarQueryParameter['to'] = to;
            }

            if (entityId !== undefined) {
                localVarQueryParameter['entity_id'] = entityId;
            }

            if (taskName) {
                localVarQueryParameter['task_name[]'] = taskName.join(COLLECTION_FORMATS.csv);
            }

            if (callType !== undefined) {
                localVarQueryParameter['call_type'] = callType;
            }

            if (operatorName) {
                localVarQueryParameter['operator_name[]'] = operatorName.join(COLLECTION_FORMATS.csv);
            }

            if (pipelineId !== undefined) {
                localVarQueryParameter['pipeline_id'] = pipelineId;
            }

            if (leadStage !== undefined) {
                localVarQueryParameter['lead_stage'] = leadStage;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CallApi - functional programming interface
 * @export
 */
export const CallApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CallApiAxiosParamCreator(configuration)
    return {
        /**
         * получить отфильтрованный список звонков.
         * @summary получить отфильтрованный список звонков.
         * @param {number} offset Начальный индекс
         * @param {number} limit Лимит
         * @param {string} [from] дата передачи лида от
         * @param {string} [to] дата передачи лида до
         * @param {string} [entityId] id лида
         * @param {Array<string>} [taskName] название задачи
         * @param {string} [callType] тип звонка
         * @param {Array<string>} [operatorName] имя оператора
         * @param {string} [pipelineId] id воронки
         * @param {string} [leadStage] id статуса амо
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCallGet(offset: number, limit: number, from?: string, to?: string, entityId?: string, taskName?: Array<string>, callType?: string, operatorName?: Array<string>, pipelineId?: string, leadStage?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CallCallListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCallGet(offset, limit, from, to, entityId, taskName, callType, operatorName, pipelineId, leadStage, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * скачать звонок (иначе не работает seek в аудио).
         * @summary скачать звонок (иначе не работает seek в аудио).
         * @param {string} url Идентификатор пользователя
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCallLinkGet(url: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CallGetLocalLinkForAudioResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCallLinkGet(url, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * получить список операторов.
         * @summary получить список операторов.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCallOperatorsGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCallOperatorsGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * получить отфильтрованный список звонков.
         * @summary получить отфильтрованный список звонков.
         * @param {string} date Дата в формате 02.01.2006
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCallStatsDateGet(date: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: RepositoryOperatorCallStat; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCallStatsDateGet(date, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * скачать звонок (иначе не работает seek в аудио).
         * @summary скачать звонок (иначе не работает seek в аудио).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCallStatusesGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LeadgenStatus>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCallStatusesGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * получить список задач.
         * @summary получить список задач.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCallTasksGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCallTasksGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * получить occupancy и кол-во операторов по направлению.
         * @summary получить occupancy и кол-во операторов по направлению.
         * @param {string} [from] дата передачи лида от
         * @param {string} [to] дата передачи лида до
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCallTasksStatsGet(from?: string, to?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CallDirectionOccupancyStat>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCallTasksStatsGet(from, to, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * получить отфильтрованный список звонков.
         * @summary получить отфильтрованный список звонков.
         * @param {string} [from] дата передачи лида от
         * @param {string} [to] дата передачи лида до
         * @param {string} [entityId] id лида
         * @param {Array<string>} [taskName] название задачи
         * @param {string} [callType] тип звонка
         * @param {Array<string>} [operatorName] имя оператора
         * @param {string} [pipelineId] id воронки
         * @param {string} [leadStage] id статуса амо
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCallXlsxGet(from?: string, to?: string, entityId?: string, taskName?: Array<string>, callType?: string, operatorName?: Array<string>, pipelineId?: string, leadStage?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CallCallsReportResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCallXlsxGet(from, to, entityId, taskName, callType, operatorName, pipelineId, leadStage, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CallApi - factory interface
 * @export
 */
export const CallApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CallApiFp(configuration)
    return {
        /**
         * получить отфильтрованный список звонков.
         * @summary получить отфильтрованный список звонков.
         * @param {number} offset Начальный индекс
         * @param {number} limit Лимит
         * @param {string} [from] дата передачи лида от
         * @param {string} [to] дата передачи лида до
         * @param {string} [entityId] id лида
         * @param {Array<string>} [taskName] название задачи
         * @param {string} [callType] тип звонка
         * @param {Array<string>} [operatorName] имя оператора
         * @param {string} [pipelineId] id воронки
         * @param {string} [leadStage] id статуса амо
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCallGet(offset: number, limit: number, from?: string, to?: string, entityId?: string, taskName?: Array<string>, callType?: string, operatorName?: Array<string>, pipelineId?: string, leadStage?: string, options?: any): AxiosPromise<CallCallListResponse> {
            return localVarFp.apiCallGet(offset, limit, from, to, entityId, taskName, callType, operatorName, pipelineId, leadStage, options).then((request) => request(axios, basePath));
        },
        /**
         * скачать звонок (иначе не работает seek в аудио).
         * @summary скачать звонок (иначе не работает seek в аудио).
         * @param {string} url Идентификатор пользователя
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCallLinkGet(url: string, options?: any): AxiosPromise<CallGetLocalLinkForAudioResponse> {
            return localVarFp.apiCallLinkGet(url, options).then((request) => request(axios, basePath));
        },
        /**
         * получить список операторов.
         * @summary получить список операторов.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCallOperatorsGet(options?: any): AxiosPromise<Array<string>> {
            return localVarFp.apiCallOperatorsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * получить отфильтрованный список звонков.
         * @summary получить отфильтрованный список звонков.
         * @param {string} date Дата в формате 02.01.2006
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCallStatsDateGet(date: string, options?: any): AxiosPromise<{ [key: string]: RepositoryOperatorCallStat; }> {
            return localVarFp.apiCallStatsDateGet(date, options).then((request) => request(axios, basePath));
        },
        /**
         * скачать звонок (иначе не работает seek в аудио).
         * @summary скачать звонок (иначе не работает seek в аудио).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCallStatusesGet(options?: any): AxiosPromise<Array<LeadgenStatus>> {
            return localVarFp.apiCallStatusesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * получить список задач.
         * @summary получить список задач.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCallTasksGet(options?: any): AxiosPromise<Array<string>> {
            return localVarFp.apiCallTasksGet(options).then((request) => request(axios, basePath));
        },
        /**
         * получить occupancy и кол-во операторов по направлению.
         * @summary получить occupancy и кол-во операторов по направлению.
         * @param {string} [from] дата передачи лида от
         * @param {string} [to] дата передачи лида до
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCallTasksStatsGet(from?: string, to?: string, options?: any): AxiosPromise<CallDirectionOccupancyStat> {
            return localVarFp.apiCallTasksStatsGet(from, to, options).then((request) => request(axios, basePath));
        },
        /**
         * получить отфильтрованный список звонков.
         * @summary получить отфильтрованный список звонков.
         * @param {string} [from] дата передачи лида от
         * @param {string} [to] дата передачи лида до
         * @param {string} [entityId] id лида
         * @param {Array<string>} [taskName] название задачи
         * @param {string} [callType] тип звонка
         * @param {Array<string>} [operatorName] имя оператора
         * @param {string} [pipelineId] id воронки
         * @param {string} [leadStage] id статуса амо
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCallXlsxGet(from?: string, to?: string, entityId?: string, taskName?: Array<string>, callType?: string, operatorName?: Array<string>, pipelineId?: string, leadStage?: string, options?: any): AxiosPromise<CallCallsReportResponse> {
            return localVarFp.apiCallXlsxGet(from, to, entityId, taskName, callType, operatorName, pipelineId, leadStage, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CallApi - object-oriented interface
 * @export
 * @class CallApi
 * @extends {BaseAPI}
 */
export class CallApi extends BaseAPI {
    /**
     * получить отфильтрованный список звонков.
     * @summary получить отфильтрованный список звонков.
     * @param {number} offset Начальный индекс
     * @param {number} limit Лимит
     * @param {string} [from] дата передачи лида от
     * @param {string} [to] дата передачи лида до
     * @param {string} [entityId] id лида
     * @param {Array<string>} [taskName] название задачи
     * @param {string} [callType] тип звонка
     * @param {Array<string>} [operatorName] имя оператора
     * @param {string} [pipelineId] id воронки
     * @param {string} [leadStage] id статуса амо
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallApi
     */
    public apiCallGet(offset: number, limit: number, from?: string, to?: string, entityId?: string, taskName?: Array<string>, callType?: string, operatorName?: Array<string>, pipelineId?: string, leadStage?: string, options?: AxiosRequestConfig) {
        return CallApiFp(this.configuration).apiCallGet(offset, limit, from, to, entityId, taskName, callType, operatorName, pipelineId, leadStage, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * скачать звонок (иначе не работает seek в аудио).
     * @summary скачать звонок (иначе не работает seek в аудио).
     * @param {string} url Идентификатор пользователя
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallApi
     */
    public apiCallLinkGet(url: string, options?: AxiosRequestConfig) {
        return CallApiFp(this.configuration).apiCallLinkGet(url, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * получить список операторов.
     * @summary получить список операторов.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallApi
     */
    public apiCallOperatorsGet(options?: AxiosRequestConfig) {
        return CallApiFp(this.configuration).apiCallOperatorsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * получить отфильтрованный список звонков.
     * @summary получить отфильтрованный список звонков.
     * @param {string} date Дата в формате 02.01.2006
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallApi
     */
    public apiCallStatsDateGet(date: string, options?: AxiosRequestConfig) {
        return CallApiFp(this.configuration).apiCallStatsDateGet(date, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * скачать звонок (иначе не работает seek в аудио).
     * @summary скачать звонок (иначе не работает seek в аудио).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallApi
     */
    public apiCallStatusesGet(options?: AxiosRequestConfig) {
        return CallApiFp(this.configuration).apiCallStatusesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * получить список задач.
     * @summary получить список задач.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallApi
     */
    public apiCallTasksGet(options?: AxiosRequestConfig) {
        return CallApiFp(this.configuration).apiCallTasksGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * получить occupancy и кол-во операторов по направлению.
     * @summary получить occupancy и кол-во операторов по направлению.
     * @param {string} [from] дата передачи лида от
     * @param {string} [to] дата передачи лида до
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallApi
     */
    public apiCallTasksStatsGet(from?: string, to?: string, options?: AxiosRequestConfig) {
        return CallApiFp(this.configuration).apiCallTasksStatsGet(from, to, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * получить отфильтрованный список звонков.
     * @summary получить отфильтрованный список звонков.
     * @param {string} [from] дата передачи лида от
     * @param {string} [to] дата передачи лида до
     * @param {string} [entityId] id лида
     * @param {Array<string>} [taskName] название задачи
     * @param {string} [callType] тип звонка
     * @param {Array<string>} [operatorName] имя оператора
     * @param {string} [pipelineId] id воронки
     * @param {string} [leadStage] id статуса амо
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallApi
     */
    public apiCallXlsxGet(from?: string, to?: string, entityId?: string, taskName?: Array<string>, callType?: string, operatorName?: Array<string>, pipelineId?: string, leadStage?: string, options?: AxiosRequestConfig) {
        return CallApiFp(this.configuration).apiCallXlsxGet(from, to, entityId, taskName, callType, operatorName, pipelineId, leadStage, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * OktellApi - axios parameter creator
 * @export
 */
export const OktellApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Возвращает уникальные статусы звонков из ClickHouse.
         * @summary Получить список всех статусов звонков.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOktellCallStatusesGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/call/call-statuses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OktellApi - functional programming interface
 * @export
 */
export const OktellApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OktellApiAxiosParamCreator(configuration)
    return {
        /**
         * Возвращает уникальные статусы звонков из ClickHouse.
         * @summary Получить список всех статусов звонков.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOktellCallStatusesGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOktellCallStatusesGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * OktellApi - factory interface
 * @export
 */
export const OktellApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OktellApiFp(configuration)
    return {
        /**
         * Возвращает уникальные статусы звонков из ClickHouse.
         * @summary Получить список всех статусов звонков.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOktellCallStatusesGet(options?: any): AxiosPromise<Array<string>> {
            return localVarFp.apiOktellCallStatusesGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OktellApi - object-oriented interface
 * @export
 * @class OktellApi
 * @extends {BaseAPI}
 */
export class OktellApi extends BaseAPI {
    /**
     * Возвращает уникальные статусы звонков из ClickHouse.
     * @summary Получить список всех статусов звонков.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OktellApi
     */
    public apiOktellCallStatusesGet(options?: AxiosRequestConfig) {
        return OktellApiFp(this.configuration).apiOktellCallStatusesGet(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * OperatorsApi - axios parameter creator
 * @export
 */
export const OperatorsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Получить список обработка на 1 оператора, по столбцу \"Задача\". далее по столбцу \"Статус\" успех и \"Результат\" не отвечает Таким образом, все соединения принимается за 60% дозвона и делим на количество операторов
         * @summary Speed-reports для операторов по проектам.
         * @param {string} dateStart Дата с
         * @param {string} dateEnd Дата по
         * @param {string} [page] По умолчанию страница 1
         * @param {string} [perPage] Количество записей на странице по умолчанию 20
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOperatorProjectReportSpeedGet: async (dateStart: string, dateEnd: string, page?: string, perPage?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dateStart' is not null or undefined
            assertParamExists('apiOperatorProjectReportSpeedGet', 'dateStart', dateStart)
            // verify required parameter 'dateEnd' is not null or undefined
            assertParamExists('apiOperatorProjectReportSpeedGet', 'dateEnd', dateEnd)
            const localVarPath = `/api/operator/project-report-speed/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (dateStart !== undefined) {
                localVarQueryParameter['dateStart'] = dateStart;
            }

            if (dateEnd !== undefined) {
                localVarQueryParameter['dateEnd'] = dateEnd;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (perPage !== undefined) {
                localVarQueryParameter['perPage'] = perPage;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Получить список обработка на 1 оператора в Excel, по столбцу \"Задача\". далее по столбцу \"Статус\" успех и \"Результат\" не отвечает Таким образом, все соединения принимается за 60% дозвона и делим на количество операторов
         * @summary Получить список обработка на 1 оператора в Excel.
         * @param {string} dateStart Дата с
         * @param {string} dateEnd Дата по
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOperatorReportExcelGet: async (dateStart: string, dateEnd: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dateStart' is not null or undefined
            assertParamExists('apiOperatorReportExcelGet', 'dateStart', dateStart)
            // verify required parameter 'dateEnd' is not null or undefined
            assertParamExists('apiOperatorReportExcelGet', 'dateEnd', dateEnd)
            const localVarPath = `/api/operator/report-excel/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (dateStart !== undefined) {
                localVarQueryParameter['dateStart'] = dateStart;
            }

            if (dateEnd !== undefined) {
                localVarQueryParameter['dateEnd'] = dateEnd;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Получить список обработка на 1 оператора, по столбцу \"Задача\". далее по столбцу \"Статус\" успех и \"Результат\" не отвечает Таким образом, все соединения принимается за 60% дозвона и делим на количество операторов
         * @summary Получить список обработка на 1 оператора.
         * @param {string} dateStart Дата с
         * @param {string} dateEnd Дата по
         * @param {string} [page] По умолчанию страница 1
         * @param {string} [perPage] Количество записей на странице по умолчанию 20
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOperatorReportSpeedGet: async (dateStart: string, dateEnd: string, page?: string, perPage?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dateStart' is not null or undefined
            assertParamExists('apiOperatorReportSpeedGet', 'dateStart', dateStart)
            // verify required parameter 'dateEnd' is not null or undefined
            assertParamExists('apiOperatorReportSpeedGet', 'dateEnd', dateEnd)
            const localVarPath = `/api/operator/report-speed/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (dateStart !== undefined) {
                localVarQueryParameter['dateStart'] = dateStart;
            }

            if (dateEnd !== undefined) {
                localVarQueryParameter['dateEnd'] = dateEnd;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (perPage !== undefined) {
                localVarQueryParameter['perPage'] = perPage;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OperatorsApi - functional programming interface
 * @export
 */
export const OperatorsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OperatorsApiAxiosParamCreator(configuration)
    return {
        /**
         * Получить список обработка на 1 оператора, по столбцу \"Задача\". далее по столбцу \"Статус\" успех и \"Результат\" не отвечает Таким образом, все соединения принимается за 60% дозвона и делим на количество операторов
         * @summary Speed-reports для операторов по проектам.
         * @param {string} dateStart Дата с
         * @param {string} dateEnd Дата по
         * @param {string} [page] По умолчанию страница 1
         * @param {string} [perPage] Количество записей на странице по умолчанию 20
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOperatorProjectReportSpeedGet(dateStart: string, dateEnd: string, page?: string, perPage?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OperatorProjectCount>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOperatorProjectReportSpeedGet(dateStart, dateEnd, page, perPage, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Получить список обработка на 1 оператора в Excel, по столбцу \"Задача\". далее по столбцу \"Статус\" успех и \"Результат\" не отвечает Таким образом, все соединения принимается за 60% дозвона и делим на количество операторов
         * @summary Получить список обработка на 1 оператора в Excel.
         * @param {string} dateStart Дата с
         * @param {string} dateEnd Дата по
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOperatorReportExcelGet(dateStart: string, dateEnd: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RestStatsReportResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOperatorReportExcelGet(dateStart, dateEnd, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Получить список обработка на 1 оператора, по столбцу \"Задача\". далее по столбцу \"Статус\" успех и \"Результат\" не отвечает Таким образом, все соединения принимается за 60% дозвона и делим на количество операторов
         * @summary Получить список обработка на 1 оператора.
         * @param {string} dateStart Дата с
         * @param {string} dateEnd Дата по
         * @param {string} [page] По умолчанию страница 1
         * @param {string} [perPage] Количество записей на странице по умолчанию 20
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOperatorReportSpeedGet(dateStart: string, dateEnd: string, page?: string, perPage?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OperatorCount>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOperatorReportSpeedGet(dateStart, dateEnd, page, perPage, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * OperatorsApi - factory interface
 * @export
 */
export const OperatorsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OperatorsApiFp(configuration)
    return {
        /**
         * Получить список обработка на 1 оператора, по столбцу \"Задача\". далее по столбцу \"Статус\" успех и \"Результат\" не отвечает Таким образом, все соединения принимается за 60% дозвона и делим на количество операторов
         * @summary Speed-reports для операторов по проектам.
         * @param {string} dateStart Дата с
         * @param {string} dateEnd Дата по
         * @param {string} [page] По умолчанию страница 1
         * @param {string} [perPage] Количество записей на странице по умолчанию 20
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOperatorProjectReportSpeedGet(dateStart: string, dateEnd: string, page?: string, perPage?: string, options?: any): AxiosPromise<OperatorProjectCount> {
            return localVarFp.apiOperatorProjectReportSpeedGet(dateStart, dateEnd, page, perPage, options).then((request) => request(axios, basePath));
        },
        /**
         * Получить список обработка на 1 оператора в Excel, по столбцу \"Задача\". далее по столбцу \"Статус\" успех и \"Результат\" не отвечает Таким образом, все соединения принимается за 60% дозвона и делим на количество операторов
         * @summary Получить список обработка на 1 оператора в Excel.
         * @param {string} dateStart Дата с
         * @param {string} dateEnd Дата по
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOperatorReportExcelGet(dateStart: string, dateEnd: string, options?: any): AxiosPromise<RestStatsReportResponse> {
            return localVarFp.apiOperatorReportExcelGet(dateStart, dateEnd, options).then((request) => request(axios, basePath));
        },
        /**
         * Получить список обработка на 1 оператора, по столбцу \"Задача\". далее по столбцу \"Статус\" успех и \"Результат\" не отвечает Таким образом, все соединения принимается за 60% дозвона и делим на количество операторов
         * @summary Получить список обработка на 1 оператора.
         * @param {string} dateStart Дата с
         * @param {string} dateEnd Дата по
         * @param {string} [page] По умолчанию страница 1
         * @param {string} [perPage] Количество записей на странице по умолчанию 20
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOperatorReportSpeedGet(dateStart: string, dateEnd: string, page?: string, perPage?: string, options?: any): AxiosPromise<OperatorCount> {
            return localVarFp.apiOperatorReportSpeedGet(dateStart, dateEnd, page, perPage, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OperatorsApi - object-oriented interface
 * @export
 * @class OperatorsApi
 * @extends {BaseAPI}
 */
export class OperatorsApi extends BaseAPI {
    /**
     * Получить список обработка на 1 оператора, по столбцу \"Задача\". далее по столбцу \"Статус\" успех и \"Результат\" не отвечает Таким образом, все соединения принимается за 60% дозвона и делим на количество операторов
     * @summary Speed-reports для операторов по проектам.
     * @param {string} dateStart Дата с
     * @param {string} dateEnd Дата по
     * @param {string} [page] По умолчанию страница 1
     * @param {string} [perPage] Количество записей на странице по умолчанию 20
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OperatorsApi
     */
    public apiOperatorProjectReportSpeedGet(dateStart: string, dateEnd: string, page?: string, perPage?: string, options?: AxiosRequestConfig) {
        return OperatorsApiFp(this.configuration).apiOperatorProjectReportSpeedGet(dateStart, dateEnd, page, perPage, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Получить список обработка на 1 оператора в Excel, по столбцу \"Задача\". далее по столбцу \"Статус\" успех и \"Результат\" не отвечает Таким образом, все соединения принимается за 60% дозвона и делим на количество операторов
     * @summary Получить список обработка на 1 оператора в Excel.
     * @param {string} dateStart Дата с
     * @param {string} dateEnd Дата по
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OperatorsApi
     */
    public apiOperatorReportExcelGet(dateStart: string, dateEnd: string, options?: AxiosRequestConfig) {
        return OperatorsApiFp(this.configuration).apiOperatorReportExcelGet(dateStart, dateEnd, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Получить список обработка на 1 оператора, по столбцу \"Задача\". далее по столбцу \"Статус\" успех и \"Результат\" не отвечает Таким образом, все соединения принимается за 60% дозвона и делим на количество операторов
     * @summary Получить список обработка на 1 оператора.
     * @param {string} dateStart Дата с
     * @param {string} dateEnd Дата по
     * @param {string} [page] По умолчанию страница 1
     * @param {string} [perPage] Количество записей на странице по умолчанию 20
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OperatorsApi
     */
    public apiOperatorReportSpeedGet(dateStart: string, dateEnd: string, page?: string, perPage?: string, options?: AxiosRequestConfig) {
        return OperatorsApiFp(this.configuration).apiOperatorReportSpeedGet(dateStart, dateEnd, page, perPage, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * SettingsApi - axios parameter creator
 * @export
 */
export const SettingsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Возвращает текущие настройки для расчета скорости обработки (числитель, знаменатель, исключенные статусы).
         * @summary Получить настройки расчета.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSettingsGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/settings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Обновляет настройки для расчета скорости обработки (числитель, знаменатель, исключенные статусы).
         * @summary Обновить настройки расчета.
         * @param {OperatorUpdateCalculationSettingsRequest} request Новые настройки
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSettingsPut: async (request: OperatorUpdateCalculationSettingsRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'request' is not null or undefined
            assertParamExists('apiSettingsPut', 'request', request)
            const localVarPath = `/api/settings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(request, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SettingsApi - functional programming interface
 * @export
 */
export const SettingsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SettingsApiAxiosParamCreator(configuration)
    return {
        /**
         * Возвращает текущие настройки для расчета скорости обработки (числитель, знаменатель, исключенные статусы).
         * @summary Получить настройки расчета.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSettingsGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OperatorCalculationSettingsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSettingsGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Обновляет настройки для расчета скорости обработки (числитель, знаменатель, исключенные статусы).
         * @summary Обновить настройки расчета.
         * @param {OperatorUpdateCalculationSettingsRequest} request Новые настройки
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSettingsPut(request: OperatorUpdateCalculationSettingsRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: string; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSettingsPut(request, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SettingsApi - factory interface
 * @export
 */
export const SettingsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SettingsApiFp(configuration)
    return {
        /**
         * Возвращает текущие настройки для расчета скорости обработки (числитель, знаменатель, исключенные статусы).
         * @summary Получить настройки расчета.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSettingsGet(options?: any): AxiosPromise<OperatorCalculationSettingsResponse> {
            return localVarFp.apiSettingsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * Обновляет настройки для расчета скорости обработки (числитель, знаменатель, исключенные статусы).
         * @summary Обновить настройки расчета.
         * @param {OperatorUpdateCalculationSettingsRequest} request Новые настройки
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSettingsPut(request: OperatorUpdateCalculationSettingsRequest, options?: any): AxiosPromise<{ [key: string]: string; }> {
            return localVarFp.apiSettingsPut(request, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SettingsApi - object-oriented interface
 * @export
 * @class SettingsApi
 * @extends {BaseAPI}
 */
export class SettingsApi extends BaseAPI {
    /**
     * Возвращает текущие настройки для расчета скорости обработки (числитель, знаменатель, исключенные статусы).
     * @summary Получить настройки расчета.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public apiSettingsGet(options?: AxiosRequestConfig) {
        return SettingsApiFp(this.configuration).apiSettingsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Обновляет настройки для расчета скорости обработки (числитель, знаменатель, исключенные статусы).
     * @summary Обновить настройки расчета.
     * @param {OperatorUpdateCalculationSettingsRequest} request Новые настройки
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public apiSettingsPut(request: OperatorUpdateCalculationSettingsRequest, options?: AxiosRequestConfig) {
        return SettingsApiFp(this.configuration).apiSettingsPut(request, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * UsersApi - axios parameter creator
 * @export
 */
export const UsersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * получить список всех источников.
         * @summary получить список всех пользователей.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/user/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * удалить пользователя
         * @summary удалить пользователя
         * @param {string} id Идентификатор пользователя
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserIdDelete: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiUserIdDelete', 'id', id)
            const localVarPath = `/api/user/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * получить платеж по id.
         * @summary получить платеж по id.
         * @param {string} id Идентификатор платежа
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserIdGet: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiUserIdGet', 'id', id)
            const localVarPath = `/api/user/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * смена пароля пользователя.
         * @summary смена пароля пользователя.
         * @param {string} id Идентификатор пользователя
         * @param {UserChangePasswordRequest} user Данные для обновления пользователя
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserIdPasswordPut: async (id: string, user: UserChangePasswordRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiUserIdPasswordPut', 'id', id)
            // verify required parameter 'user' is not null or undefined
            assertParamExists('apiUserIdPasswordPut', 'user', user)
            const localVarPath = `/api/user/{id}/password`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(user, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * обновление пользователя.
         * @summary обновление пользователя.
         * @param {string} id Идентификатор пользователя
         * @param {UserUpdateUserRequest} user Данные для обновления пользователя
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserIdPut: async (id: string, user: UserUpdateUserRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiUserIdPut', 'id', id)
            // verify required parameter 'user' is not null or undefined
            assertParamExists('apiUserIdPut', 'user', user)
            const localVarPath = `/api/user/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(user, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * создание пользователя.
         * @summary создание пользователя.
         * @param {UserCreateUserRequest} user Данные пользователя
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserPost: async (user: UserCreateUserRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'user' is not null or undefined
            assertParamExists('apiUserPost', 'user', user)
            const localVarPath = `/api/user/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(user, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UsersApi - functional programming interface
 * @export
 */
export const UsersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UsersApiAxiosParamCreator(configuration)
    return {
        /**
         * получить список всех источников.
         * @summary получить список всех пользователей.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUserGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UserUserResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUserGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * удалить пользователя
         * @summary удалить пользователя
         * @param {string} id Идентификатор пользователя
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUserIdDelete(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserUserResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUserIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * получить платеж по id.
         * @summary получить платеж по id.
         * @param {string} id Идентификатор платежа
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUserIdGet(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserUserResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUserIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * смена пароля пользователя.
         * @summary смена пароля пользователя.
         * @param {string} id Идентификатор пользователя
         * @param {UserChangePasswordRequest} user Данные для обновления пользователя
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUserIdPasswordPut(id: string, user: UserChangePasswordRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserUserResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUserIdPasswordPut(id, user, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * обновление пользователя.
         * @summary обновление пользователя.
         * @param {string} id Идентификатор пользователя
         * @param {UserUpdateUserRequest} user Данные для обновления пользователя
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUserIdPut(id: string, user: UserUpdateUserRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserUserResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUserIdPut(id, user, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * создание пользователя.
         * @summary создание пользователя.
         * @param {UserCreateUserRequest} user Данные пользователя
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUserPost(user: UserCreateUserRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserUserResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUserPost(user, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UsersApi - factory interface
 * @export
 */
export const UsersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UsersApiFp(configuration)
    return {
        /**
         * получить список всех источников.
         * @summary получить список всех пользователей.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserGet(options?: any): AxiosPromise<Array<UserUserResponse>> {
            return localVarFp.apiUserGet(options).then((request) => request(axios, basePath));
        },
        /**
         * удалить пользователя
         * @summary удалить пользователя
         * @param {string} id Идентификатор пользователя
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserIdDelete(id: string, options?: any): AxiosPromise<UserUserResponse> {
            return localVarFp.apiUserIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * получить платеж по id.
         * @summary получить платеж по id.
         * @param {string} id Идентификатор платежа
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserIdGet(id: string, options?: any): AxiosPromise<UserUserResponse> {
            return localVarFp.apiUserIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * смена пароля пользователя.
         * @summary смена пароля пользователя.
         * @param {string} id Идентификатор пользователя
         * @param {UserChangePasswordRequest} user Данные для обновления пользователя
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserIdPasswordPut(id: string, user: UserChangePasswordRequest, options?: any): AxiosPromise<UserUserResponse> {
            return localVarFp.apiUserIdPasswordPut(id, user, options).then((request) => request(axios, basePath));
        },
        /**
         * обновление пользователя.
         * @summary обновление пользователя.
         * @param {string} id Идентификатор пользователя
         * @param {UserUpdateUserRequest} user Данные для обновления пользователя
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserIdPut(id: string, user: UserUpdateUserRequest, options?: any): AxiosPromise<UserUserResponse> {
            return localVarFp.apiUserIdPut(id, user, options).then((request) => request(axios, basePath));
        },
        /**
         * создание пользователя.
         * @summary создание пользователя.
         * @param {UserCreateUserRequest} user Данные пользователя
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserPost(user: UserCreateUserRequest, options?: any): AxiosPromise<UserUserResponse> {
            return localVarFp.apiUserPost(user, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UsersApi - object-oriented interface
 * @export
 * @class UsersApi
 * @extends {BaseAPI}
 */
export class UsersApi extends BaseAPI {
    /**
     * получить список всех источников.
     * @summary получить список всех пользователей.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public apiUserGet(options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).apiUserGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * удалить пользователя
     * @summary удалить пользователя
     * @param {string} id Идентификатор пользователя
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public apiUserIdDelete(id: string, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).apiUserIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * получить платеж по id.
     * @summary получить платеж по id.
     * @param {string} id Идентификатор платежа
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public apiUserIdGet(id: string, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).apiUserIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * смена пароля пользователя.
     * @summary смена пароля пользователя.
     * @param {string} id Идентификатор пользователя
     * @param {UserChangePasswordRequest} user Данные для обновления пользователя
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public apiUserIdPasswordPut(id: string, user: UserChangePasswordRequest, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).apiUserIdPasswordPut(id, user, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * обновление пользователя.
     * @summary обновление пользователя.
     * @param {string} id Идентификатор пользователя
     * @param {UserUpdateUserRequest} user Данные для обновления пользователя
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public apiUserIdPut(id: string, user: UserUpdateUserRequest, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).apiUserIdPut(id, user, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * создание пользователя.
     * @summary создание пользователя.
     * @param {UserCreateUserRequest} user Данные пользователя
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public apiUserPost(user: UserCreateUserRequest, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).apiUserPost(user, options).then((request) => request(this.axios, this.basePath));
    }
}
